import { render, staticRenderFns } from "./activityCreateExam.html?vue&type=template&id=50015800&scoped=true&external"
import script from "./activityCreateExam.vue?vue&type=script&lang=js"
export * from "./activityCreateExam.vue?vue&type=script&lang=js"
import style0 from "./activityCreateExam.css?vue&type=style&index=0&id=50015800&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50015800",
  null
  
)

export default component.exports